import { notification } from "antd";
import { duration } from "moment";
import GetIntlCustom from "./GetIntlCustom";

const OpenNotificationWithIcon = (
  type,
  messageId,
  systemMessage = "",
  descriptionId
) => {
  const selectedLocale = localStorage.getItem("selectedlanguage") || "fr-FR";
  const intl = GetIntlCustom(selectedLocale);
  const message = messageId ? intl.formatMessage({ id: messageId }) : "";
  const description = descriptionId
    ? intl.formatMessage({ id: descriptionId })
    : "";
  notification[type]({
    message: message,
    description: systemMessage + description,
    showProgress: true,
    duration: 4,
  });
};

export default OpenNotificationWithIcon;
